import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Los dos guards esperan a `ensureChecked()` antes de decidir.
 *
 * `AppComponent` lanza `sessionCheck()` sin aguardarlo, y el router evalúa el
 * guard en cuanto arranca la navegación inicial. Leyendo `authed` de forma
 * síncrona se decidía con el valor que tuviera el servicio recién construido,
 * no con el estado real de la sesión: con el token caducado la aplicación se
 * abría igual y se quedaba sin datos hasta que el usuario recargaba.
 */

@Injectable({
    providedIn: 'root',
})
export class AuthedGuard {
    constructor(
        private authService: AuthService,
        private router: Router
    ) {}

    async canActivate(): Promise<boolean> {
        await this.authService.ensureChecked();

        if (this.authService.authed) return true;

        this.router.navigate(['/auth/login']);
        return false;
    }
}

@Injectable({
    providedIn: 'root',
})
export class NotAuthedGuard {
    constructor(
        private authService: AuthService,
        private router: Router
    ) {}

    async canActivate(): Promise<boolean> {
        await this.authService.ensureChecked();

        if (!this.authService.authed) return true;

        this.router.navigate(['/ofs']);
        return false;
    }
}
